
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybackQualityOptionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybackQualityOption"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bitrate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDefault"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"fragment PlaybackQualityOptionFields on PlaybackQualityOption {\n  id\n  label\n  description\n  bitrate\n  isDefault\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
